export const SCROLL_STATES = [
    { meshScale: 1.0, meshX: 0, meshY: 0, particleOp: 0.85, lineOp: 0.14, cameraZ: 7, controlsOn: true },
    { meshScale: 0.52, meshX: 2.6, meshY: 0.3, particleOp: 0.38, lineOp: 0.05, cameraZ: 9, controlsOn: false },
    { meshScale: 0.38, meshX: 3.0, meshY: -0.4, particleOp: 0.45, lineOp: 0.06, cameraZ: 9, controlsOn: false },
    { meshScale: 0.22, meshX: 3.4, meshY: 0, particleOp: 0.22, lineOp: 0.03, cameraZ: 12, controlsOn: false },
    { meshScale: 0.22, meshX: 3.4, meshY: 0, particleOp: 0.22, lineOp: 0.03, cameraZ: 12, controlsOn: false },
    { meshScale: 0.22, meshX: 3.4, meshY: 0, particleOp: 0.20, lineOp: 0.02, cameraZ: 13, controlsOn: false },
    { meshScale: 0.75, meshX: 0, meshY: 0, particleOp: 0.65, lineOp: 0.10, cameraZ: 8, controlsOn: false },
]
